import { h } from 'preact'

const BackIcon = ({
  size = 92,
  className,
  color = '#429EFF',
  onClick,
}: {
  size?: number
  className?: string
  color?: string
  onClick?: () => void
}) => (
  <svg
    className={className}
    onClick={onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
  >
    <path
      fill={color}
      d="M28 15.744c0-0.32-0.096-0.608-0.288-0.832-0.16-0.224-0.416-0.32-0.672-0.32h-19.552l4.928-4.576c0.16-0.128 0.256-0.352 0.288-0.576 0.064-0.224 0.032-0.48-0.032-0.704s-0.192-0.416-0.352-0.544c-0.16-0.128-0.352-0.192-0.544-0.192-0.224 0-0.448 0.096-0.64 0.288l-6.816 6.592c-0.096 0.096-0.192 0.224-0.224 0.384-0.064 0.16-0.096 0.32-0.096 0.48s0.032 0.32 0.096 0.48c0.032 0.128 0.128 0.288 0.224 0.384l6.816 7.072c0.096 0.128 0.192 0.192 0.32 0.256 0.128 0.032 0.256 0.064 0.384 0.064s0.256-0.064 0.352-0.128c0.128-0.064 0.224-0.16 0.32-0.256 0.064-0.128 0.16-0.256 0.192-0.416 0.032-0.128 0.064-0.288 0.032-0.448 0-0.16-0.032-0.288-0.096-0.448-0.064-0.128-0.128-0.256-0.224-0.352l-4.928-5.056h19.552c0.256 0 0.512-0.128 0.672-0.352 0.192-0.192 0.288-0.512 0.288-0.8v0z"
    />
  </svg>
)

export default BackIcon
